import { Box } from '@mui/material'
import { Seo } from '@/components/common'
import {
  HeroSection,
  TrustSection,
  ProblemSection,
} from '@/components/sections'

/**
 * Home Page Component
 * Landing page with hero, trust indicators, and problem statement
 */
export const HomePage = () => {
  return (
    <Box>
      <Seo
        title="Leru Systems - Websites That Generate Plumbing Leads"
        description="Professional websites for plumbing companies that generate more leads and customers. Fast, modern, mobile-friendly websites designed to grow your business."
        path="/"
      />
      <HeroSection />
      <TrustSection />
      <ProblemSection />
    </Box>
  )
}
